import { useDrag } from 'react-dnd';
import { useMultiCommon } from './useMultiCommon';
export var useMultiDrag = function useMultiDrag(spec) {
  return useMultiCommon(spec, useDrag);
};